<template>
  <div class="base-echart" ref="chart"></div>
</template>

<script>
/**
 * 基础echarts图表组件
 */
import * as echarts from "echarts";
import { mapGetters } from "vuex";
export default {
  components: {},
  props: {
    chartOption: {
      type: Object,
      default() {
        return {};
      },
    },
    //是否动态饼图，（轮流高亮）
    activePie: {
      type: Boolean,
      default: false,
    },
    //轮播间隔，毫秒
    activeInterval: {
      type: Number,
      default() {
        return 1000 * 2;
      },
    },
    // 在options 更改后是否需要先clear再setOption
    clearBeforeSetOption: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      chartInstance: "",
      changePieInterval: null,
    };
  },
  computed: {
    ...mapGetters(["theme"]),
  },
  methods: {
    init() {
      let el = this.$refs.chart;
      let myChart = echarts.init(el);
      this.chartInstance = myChart;
      this.setOption(this.chartOption);
      if (this.activePie) {
        this.initHighlightPie();
      }
    },
    initHighlightPie() {
      const chartInstance = this.chartInstance;
      if (!chartInstance) return;

      let currentIndex = -1;
      let dataLen = 0;
      let option = this.chartOption || {};

      if (option.series[0]) {
        dataLen = option.series[0].data.length;
      }
      clearInterval(this.changePieInterval);
      this.changePieInterval = setInterval(() => {
        if (dataLen > 0) {
          currentIndex = (currentIndex + 1) % dataLen;
        }

        // console.log(currentIndex);
        this.highlightPie(currentIndex);
      }, this.activeInterval); // 设置自动切换高亮图形的定时器
    },
    highlightPie(currentIndex = -1) {
      const chartInstance = this.chartInstance;
      if (!chartInstance) return;
      // 取消所有高亮并高亮当前图形
      // 遍历饼图数据，取消所有图形的高亮效果
      let option = this.chartOption || {};
      if (option.series[0]) {
        for (var idx in option.series[0].data)
          chartInstance.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: idx,
          });
        // 高亮当前图形
        chartInstance.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: currentIndex,
        });
      }
    },

    setOption(option) {
      if (this.chartInstance) {
        if (this.clearBeforeSetOption) {
          this.chartInstance.clear();
        }

        this.chartInstance.setOption(option);
      }
    },
    resize() {
      this.$nextTick(() => {
        if (this.chartInstance) {
          this.chartInstance.resize();
        }
      });
    },
    //获取echart实例
    gtChartInstance() {
      return this.chartInstance;
    },

    getDataURL(type = "png", fileNames = "chart") {
      let src = "";
      if (this.chartInstance) {
        src = this.chartInstance.getDataURL({
          type: type,
        });
      }

      if (src) {
        let base64URL = src;
        let fileName = fileNames;
        // 创建a标签，用于触发下载
        const a = document.createElement("a");
        // 将 a 标签的 download 属性设置为要下载的文件名
        a.download = fileName || "image";
        // 创建 Blob 对象，并获取 base64 数据的 MIME 类型
        const mimeType = base64URL.match(/:(.*?);/)[1];
        console.log(mimeType);
        // 将 base64 数据转换为字节数组
        const byteCharacters = atob(base64URL.split(",")[1]);
        const byteNumbers = new Array(byteCharacters.length);
        // 将字节数组填充到 Uint8Array 中
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        // 创建 Blob 对象
        const blob = new Blob([byteArray], { type: mimeType });
        // 将 Blob 对象的 URL 赋值给 a 标签的 href 属性
        a.href = URL.createObjectURL(blob);

        a.click();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
    window.addEventListener("resize", this.resize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
    clearInterval(this.changePieInterval);
  },
  watch: {
    chartOption(val) {
      // console.log(val);
      this.setOption(val);
      this.resize();
      if (this.activePie) {
        this.initHighlightPie();
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.base-echart {
  height: 100%;
  width: 100%;
  min-width: 100px;
  min-height: 100px;
}
</style>